import { X, Repeat } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function RecurringModal({ 
  customer, 
  day, 
  setDay, 
  timeSlot, 
  setTimeSlot,
  frequency,
  setFrequency,
  onZoneChange,
  onSubmit, 
  onClose 
}) {
  if (!customer) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md shadow-2xl">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="font-bold text-lg flex items-center gap-2">
            <Repeat className="w-5 h-5 text-purple-500" />
            Créer un récurrent
          </h3>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X className="w-5 h-5" />
          </Button>
        </div>
        <div className="p-4 space-y-4">
          <p className="text-sm text-slate-600">
            Créer un ramassage & livraison récurrent pour <strong>{customer.first_name} {customer.last_name}</strong>
          </p>
          <p className="text-xs text-amber-600 bg-amber-50 p-2 rounded">
            Note : Seuls les jours configurés dans "Gestion créneaux {'>'} Config récurrents" seront acceptés.
          </p>
          
          <div>
            <Label className="text-sm font-medium">Zone</Label>
            <Select 
              value={customer.zone_id || "lyon"} 
              onValueChange={onZoneChange}
            >
              <SelectTrigger>
                <SelectValue placeholder="Choisir une zone" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="lyon">Lyon (Lun/Ven)</SelectItem>
                <SelectItem value="saint-rambert">Saint-Rambert (Mar)</SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          <div>
            <Label className="text-sm font-medium">Jour</Label>
            <Select value={day} onValueChange={setDay}>
              <SelectTrigger>
                <SelectValue placeholder="Choisir un jour" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="0">Lundi</SelectItem>
                <SelectItem value="1">Mardi</SelectItem>
                <SelectItem value="4">Vendredi</SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          <div>
            <Label className="text-sm font-medium">Créneau horaire</Label>
            <Select value={timeSlot} onValueChange={setTimeSlot}>
              <SelectTrigger>
                <SelectValue placeholder="Choisir un créneau" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="matin">Matin (8h-12h)</SelectItem>
                <SelectItem value="midi">Midi (12h-14h)</SelectItem>
                <SelectItem value="soir">Soir (17h-20h)</SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          <div>
            <Label className="text-sm font-medium">Fréquence</Label>
            <Select value={frequency || "weekly"} onValueChange={setFrequency}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="weekly">Chaque semaine</SelectItem>
                <SelectItem value="biweekly">1 semaine sur 2</SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          <div className="flex gap-2 justify-end pt-2">
            <Button variant="outline" onClick={onClose}>
              Annuler
            </Button>
            <Button 
              onClick={onSubmit}
              className="bg-purple-600 hover:bg-purple-700"
              disabled={!day || !timeSlot}
            >
              <Repeat className="w-4 h-4 mr-1" />
              Créer
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
